/* global axios */
import ApiClient from './ApiClient';

// V1 · Permisos de Sucursal por Agente · 2026-05-14 (Victor)
// GET /agent_branch_access → { users: [...], branches: [...] }
// PUT /agent_branch_access/:id { branch_ids: [3, 1] } → user actualizado
class AgentBranchAccessAPI extends ApiClient {
  constructor() {
    super('agent_branch_access', { accountScoped: true });
  }

  async getAll() {
    const res = await axios.get(this.url);
    return res.data;
  }

  async update(userId, branchIds) {
    const res = await axios.put(`${this.url}/${userId}`, { branch_ids: branchIds });
    return res.data;
  }
}

export default new AgentBranchAccessAPI();
